// Cada portal tiene su propio manifest para que el acceso directo creado con
// "Añadir a la pantalla de inicio" abra el portal desde el que se creó, y no la raíz.
// Los start_url de cada manifest están en public/manifest*.json.
const DEFAULT_MANIFEST = "manifest.json"

const PORTALS = [
  {
    manifest: "manifest-workers.json", //start_url: configFront.workersURL
    matches: path =>
      path.startsWith("/workers") ||
      path.startsWith("/center/") ||
      path.startsWith("/superadmin")
  },
  {
    manifest: "manifest-customer.json", //start_url: /login
    matches: path =>
      path.startsWith("/customer") || path === "/login" || path === "/logout"
  }
]

export const manifestForPath = path => {
  const portal = PORTALS.find(p => p.matches(path))
  return portal ? portal.manifest : DEFAULT_MANIFEST
}

// Reescribe el href del <link rel="manifest"> de index.html conservando su ruta base
// (%PUBLIC_URL%), que puede no ser el dominio raíz.
export const syncManifest = (path = window.location.pathname) => {
  const link = document.querySelector('link[rel="manifest"]')
  if (!link) return

  const currentHref = link.getAttribute("href") || DEFAULT_MANIFEST
  const base = currentHref.replace(/[^/]*$/, "")
  const nextHref = base + manifestForPath(path)

  if (currentHref !== nextHref) link.setAttribute("href", nextHref)
}

export default syncManifest
